<template>
    <div class="send-email-config">
        <div class="config-field">
            <label>Gönderici (From)</label>
            <a-select
                v-model="localConfig.from"
                show-search
                placeholder="Gönderici mail adresi seçin"
                style="width: 100%;"
                @change="emitChange"
            >
                <a-select-option
                    v-for="mail in senderMails"
                    :key="mail.mail"
                    :value="mail.mail"
                >
                    {{ mail.mail }} ({{ getMailLabel(mail) }})
                </a-select-option>
            </a-select>
        </div>

        <div class="config-field">
            <label>Alıcı Tipi (To)</label>
            <a-radio-group v-model="localConfig.toType" @change="emitChange" button-style="solid">
                <a-radio-button value="static">Sabit E-posta</a-radio-button>
                <a-radio-button value="dynamic">Dinamik</a-radio-button>
            </a-radio-group>
        </div>

        <div v-if="localConfig.toType === 'static'" class="config-field">
            <label>Alıcı E-posta Adresleri</label>
            <a-select
                v-model="localConfig.toStatic"
                mode="tags"
                placeholder="E-posta adresleri girin"
                style="width: 100%;"
                @change="emitChange"
            >
            </a-select>
            <small>E-posta adreslerini virgül ile ayırarak girebilirsiniz</small>
        </div>

        <div v-if="localConfig.toType === 'dynamic'" class="config-field">
            <label>Dinamik Alıcılar</label>
            <a-select
                v-model="localConfig.toDynamic"
                mode="multiple"
                placeholder="Dinamik alıcı seçin"
                style="width: 100%;"
                @change="emitChange"
            >
                <a-select-option value="task_owner">Görev Sahibi</a-select-option>
                <a-select-option value="task_assignees">Görev Atananları</a-select-option>
                <a-select-option value="task_followers">Görev Takipçileri</a-select-option>
                <a-select-option value="task_collaborators">Görev İşbirlikçileri</a-select-option>
                <a-select-option value="task_relation_visitor">İlişkili Müşteri</a-select-option>
            </a-select>
        </div>

        <div class="config-field">
            <label>CC (opsiyonel)</label>
            <a-select
                v-model="localConfig.cc"
                mode="tags"
                placeholder="CC e-posta adresleri"
                style="width: 100%;"
                @change="emitChange"
            >
            </a-select>
        </div>

        <div class="config-field">
            <label>BCC (opsiyonel)</label>
            <a-select
                v-model="localConfig.bcc"
                mode="tags"
                placeholder="BCC e-posta adresleri"
                style="width: 100%;"
                @change="emitChange"
            >
            </a-select>
        </div>

        <div class="config-field">
            <label>Konu (Subject)</label>
            <div class="input-with-variables">
                <a-input
                    v-model="localConfig.subject"
                    :placeholder="'E-posta konusu ({{task.title}} gibi dinamik değişkenler kullanabilirsiniz)'"
                    @change="emitChange"
                />
                <a-button type="link" size="small" @click="showVariablesPicker = true">
                    <i class="material-icons">code</i>
                    Değişkenler
                </a-button>
            </div>
        </div>

        <div class="config-field">
            <label>İçerik (Body)</label>
            <div class="input-with-variables">
                <a-textarea
                    v-model="localConfig.body"
                    :placeholder="'E-posta içeriği (HTML desteklenir, {{task.description}} gibi dinamik değişkenler kullanabilirsiniz)'"
                    :rows="6"
                    @change="emitChange"
                />
                <a-button type="link" size="small" @click="showVariablesPicker = true">
                    <i class="material-icons">code</i>
                    Değişkenler
                </a-button>
            </div>
            <small>HTML etiketleri kullanabilirsiniz. Örn: &lt;b&gt;kalın&lt;/b&gt;, &lt;br&gt; satır atla</small>
        </div>

        <DynamicVariablesPicker
            v-if="showVariablesPicker"
            :visible="showVariablesPicker"
            @close="showVariablesPicker = false"
            @select="insertVariable"
        />
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import DynamicVariablesPicker from "./DynamicVariablesPicker.vue";

export default {
    name: "SendEmailConfig",
    components: {
        DynamicVariablesPicker
    },
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localConfig: {
                from: '',
                toType: 'dynamic',
                toStatic: [],
                toDynamic: [],
                cc: [],
                bcc: [],
                subject: '',
                body: ''
            },
            showVariablesPicker: false
        };
    },
    computed: {
        ...mapGetters({
            allowedMailAddresses: "mail/allowedMailAddresses"
        }),
        ...mapState({
            users: state => state.user.users.data || [],
            subjects: state => state.subject.subjects.data || []
        }),
        senderMails() {
            return this.allowedMailAddresses.filter(mail => 
                mail.isSenderMail ? mail.isSenderVerified : mail.isSender
            );
        }
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        },

        getMailLabel(mail) {
            if (mail.type === 'user') {
                const user = this.users.find(u => u._id === mail.user);
                return user ? user.name : 'Kullanıcı';
            }
            if (mail.type === 'department') {
                const dept = this.subjects.find(s => s._id === mail.department);
                return dept ? dept.languageContent[this.$i18n.locale].name : 'Departman';
            }
            return 'Mail';
        },

        insertVariable(variable) {
            // Şimdilik subject'e ekle - geliştirilecek
            this.localConfig.subject += ` {{${variable}}}`;
            this.emitChange();
        }
    }
};
</script>

<style lang="scss" scoped>
.send-email-config {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }

        small {
            display: block;
            color: #999;
            font-size: 12px;
            margin-top: 6px;
        }

        .input-with-variables {
            display: flex;
            gap: 8px;
            align-items: flex-start;

            .ant-input,
            .ant-textarea {
                flex: 1;
            }
        }
    }
}
</style>
